export default {
  "activities.title": "Activities & Programs",
  "activities.subtitle": "A comprehensive offering for all levels and ages",
  "activities.tab1": "Adult Lessons",
  "activities.tab2": "Kids & Teens",
  "activities.tab3": "Kid Summer Camp",
  "activities.tab4": "Coach Training",
  "activities.tab5": "ITF Competitions",
  "activities.tab6": "Court Rental",
  "activities.adults.title": "Adult Lessons",
  "activities.adults.desc": "Programs tailored to your level, from beginner to seasoned competitor. Our certified coaches guide you through your progression.",
  "activities.adults.item1": "Beginner lessons — Learn the fundamentals",
  "activities.adults.item2": "Amateur lessons — Refine your technique",
  "activities.adults.item3": "Competitor training — Prepare for tournaments",
  "activities.adults.item4": "Sparring & Matches — Play with leveled partners",
  "activities.kids.title": "Kids & Teens (5–16 years)",
  "activities.kids.desc": "Tennis school for young talents. Technical, tactical and mental development in a fun and stimulating environment.",
  "activities.kids.item1": "Mini Tennis (5–8) — Coordination and first rallies",
  "activities.kids.item2": "Junior (9–12) — Technique and first matches",
  "activities.kids.item3": "Performance (13–16) — Competition preparation",
  "activities.kids.item4": "Holiday camps — Intensive programs during school breaks",
  "activities.camp.title": "Kid Summer Camp 2026",
  "activities.camp.desc": "The must-attend summer program for youth aged 5 to 16. Two sessions available with varied activities combining sports, technology and personal development.",
  "activities.camp.session1": "Session 1: June 8 – July 3, 2026",
  "activities.camp.session2": "Session 2: July 6 – August 31, 2026",
  "activities.camp.schedule": "Monday – Friday, 9:00 AM – 3:00 PM",
  "activities.camp.activity1": "Daily tennis with certified coaches",
  "activities.camp.activity2": "Tactical & mental workshops",
  "activities.camp.activity3": "Personal development",
  "activities.camp.activity4": "Introduction to AI & technology",
  "activities.camp.activity5": "Yoga, Pilates & mobility",
  "activities.camp.activity6": "Mini-football, ping-pong, mini-basketball, trampoline",
  "activities.camp.cta": "Enroll My Child",
  "activities.coaching.title": "International Coach Training",
  "activities.coaching.desc": "A 4-day intensive program to train the new generation of African coaches. Certified training by Coach Boutoto Rapontchombo, internationally certified.",
  "activities.coaching.item1": "Modern coaching techniques",
  "activities.coaching.item2": "Athlete mental preparation",
  "activities.coaching.item3": "Professional coaching framework",
  "activities.coaching.item4": "Sports leadership and team management",
  "activities.coaching.cta": "Learn More",
  "activities.itf.title": "ITF Competitions & Tournaments",
  "activities.itf.desc": "TCD hosts international ITF J30 tournaments, attracting the world's best young players. A unique opportunity to shine on the international stage.",
  "activities.itf.item1": "ITF J30 Tournaments — 30 world ranking points",
  "activities.itf.item2": "Categories: Men's Singles, Women's Singles, Doubles",
  "activities.itf.item3": "Regular interclub competitions",
  "activities.itf.item4": "High-level sparring available",
  "activities.itf.cta": "View Calendar",
  "activities.rental.title": "Court Rental",
  "activities.rental.desc": "Book your court in seconds via our mobile app. Available 7 days a week from 8 AM to 10 PM.",
  "activities.rental.item1": "Instant booking via mobile app",
  "activities.rental.item2": "6 courts available (center, standard, training)",
  "activities.rental.item3": "Floodlights on all courts",
  "activities.rental.item4": "Equipment available for rent",
  "activities.rental.cta": "Download App"
}